import { useSelector } from "react-redux";
import styled from "styled-components";
import { showModal } from "../../features/modal/modalSlice";
import { useDispatch } from "react-redux";
import { setSelectedKayitliYuk } from "../../features/kayit/kayitSlice";
import { MdMoreHoriz } from "react-icons/md";

const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;

    .content {
      width: 100% !important;
      padding: 15px !important;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      /* border: 1px solid ; */
      /* border-color: ${({ theme }) => theme.mainBorderColor}; */
      background-color: var(--color-light);
      .more{
        position: absolute;
        right: 10px;
        top: 10px;
        span{
          font-size: 25px;
          color: ${({ theme }) => theme.mainTextColor};

          cursor: pointer;
        }
        .option{
          position: absolute;
          right: 30px;
          top: 10px;
          color: var(--color-main);
          cursor: pointer;
        }
      }
      .row {
        width: 95%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 15px;
        text-align: center;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-sm);
          width: 130px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: ${({ theme }) => theme.mainTextColor};

        }
      }
    }
  }
`;
 
const KayitliYuklerContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();
  return (
    <Container theme={theme}>
      <div className="container">
        <div className="content">
          <div onClick={(e)=> e.stopPropagation()}  className="more">
            <span onClick={() => {dispatch(showModal("yukKayitItemOptions")); dispatch(setSelectedKayitliYuk(data))}}>
              <MdMoreHoriz />
            </span>
          </div>
          <div className="row">
            <div className="col">{data?.saveLoadName}</div>
            <div className="col">{data?.senderAdressCity}</div>
            <div className="col">{data?.senderAdressTown}</div>
            <div className="col">{data?.receiverCity}</div>
            <div className="col">{data?.receiverAdressTown}</div>
            <div className="col">{data?.truckType}</div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default KayitliYuklerContainer;
